<template>
  <div class="container">
    <div v-if="stage == 1">
      <button class="btn btn-primary" @click="stage = 2">
        Acione o seu Seguro
      </button>
    </div>
    <div v-if="stage == 2" class="row">
      <div
        class="card col-md-6"
        style="width: 18rem;cursor: pointer"
        @click="goToMainPage"
      >
        <div class="card-body">
          <h5 class="card-title">Abrir Aviso</h5>
        </div>
      </div>
      <div
        class="card col-md-6"
        style="width: 18rem;cursor: pointer"
        @click="goToConsultar"
      >
        <div class="card-body">
          <h5 class="card-title">Consultar Aviso</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stage: 1,
    };
  },
  methods: {
    goToMainPage() {
      let routeData = this.$router.resolve({ name: "Home" });
      window.open(routeData.href, "_blank");
    },
    goToConsultar() {
      window.open("https://www.webprotecao.com.br/axa", "_blank");
    },
  },
};
</script>
